<script>

import router from '../../index'
export default {
  created() {
        router.push('/login'); 
  }
}
</script>